import axios from "axios";
import { ensureArray } from "../utils/validateResponseApi";
import { useDataAuth } from "./useDataAuth";
import { isNotEmptyObject, safeParseJSON, safeStringifyJSON } from "../utils/jsonValidator";

export function useApiTrigger() {
    const [{ userSession }] = useDataAuth();

    const getDataRequest = async (config, variables) => {
        if (!config?.trigger?.length) return;

        const apiConfig = config.trigger[0];
        try {
            let bodyData = apiConfig.bodyData
            if (isNotEmptyObject(variables)) {
                let varb = safeParseJSON(bodyData?.variables);
                for (let key in variables) {
                    varb[key] = variables[key];
                }
                bodyData.variables = safeStringifyJSON(varb, 0);
            }
            const response = await axios({
                method: apiConfig.method,
                url: apiConfig.url,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userSession?.token}`
                },
                data: bodyData,
            });
            return ensureArray(response.data);
        } catch (err) {
            return [];
        }
    };

    return { getDataRequest };
}
